import DatePicker from 'react-datepicker'
import React, {useRef} from "react";
import ShowCalendar from "@/components/common/GenericDatePicker/ShowCalendar";

interface GenericDatePickerProps {
  selected: Date | null
  onChange: Function
}

const GenericDatePicker: React.FC<GenericDatePickerProps>
  = ({ selected, onChange }) => {
  const inputRef = useRef(null)
  return <DatePicker
    isClearable
    selected={selected}
    onChange={onChange}
    customInput={<ShowCalendar ref={inputRef}/>}
  />
}




export default GenericDatePicker;